import axios from 'axios';
import { api } from '../../../stores/api';
import { app } from '../../../stores/app';
import { routes } from '../../../stores/store';
import { canWrite } from '../../shared/Permissions/writeAccess';
import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import { z } from 'zod';
import { get } from 'svelte/store';
// import { stringify } from 'flatted';

export class RouteOnMap extends EventTarget {
    private points: Array<any> = [];
    private map: any;
    private route: any = null;
    private loadedArea: any = null;
    private recentZoom: number | null = null;
    private routeStyle: any = [
        { strokeWeight: '7px', strokeColor: '#5f9cfd', strokeOpacity: '1', lineCap: 'butt' },
    ];
    private api: any;
    private apiController: any;
    private token: string | null = null;
    private connectionId: number | null = null;
    private routeTypeId: number | null = null;
    private onZoomToBoundsTimeout: any;
    private routeDragPointer: any = null;
    private routeDragging: any = null;
    private routeDragPointerHideTimeout: any = null;
    private uncommitted = false;
    private uncommittedMapBar: any = null;
    private routeLayer: any = null;
    private labelsLayer: any = null;

    constructor() {
        super();
        /** @ts-ignore */
        this.map = Targeo.Base.Map;
        this.api = null;
        this.apiController = api.subscribe(
            function (this: RouteOnMap, v: any) {
                this.api = v;
            }.bind(this)
        );
        this.map.listen('onMoveEnd', this.routeFetch, false, this);
        this.map.listen('onZoomChange', this.routeFetch, false, this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onRouteDrag = this.onRouteDrag.bind(this);
        this.onRouteDragEnd = this.onRouteDragEnd.bind(this);
        this.uncommittedMapBar = document.createElement('div');
        this.uncommittedMapBar.style.cssText =
            'display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 20px; width: 100%; height: 30px; background-color: #70a0ff;';
        this.routeLayer = this.map.objectLayerAdd('route', { zIndex: 9 });
        this.labelsLayer = new Targeo.TileLayer('labels', {
            tileUrl:
                _TARGEO_GLOBALS.url +
                'Tile_eu.html?m=labels&d=0&x={x}&y={y}&z={z}&vn=3_0&k=' +
                _TARGEO_GLOBALS.k,
            visible: true,
            zIndex: 10,
            maxtries: 16,
        });
        this.map.tileLayerAdd(
            new Targeo.TileLayer('junctions', {
                tileUrl: function (coords, zoom) {
                    return '{dynsrv}/Tile_cartoAM.html?tpl=91fda72f-e33d-4eaa-bb06-52a97879a365&x={x}&y={y}&z={z}'
                        .replace('{z}', zoom)
                        .replace('{x}', coords.x)
                        .replace('{y}', coords.y)
                        .replace(
                            '{dynsrv}',
                            _TARGEO_GLOBALS.urlDyn.replace('#', ((coords.x + coords.y) % 3) + 1)
                        );
                },
                opacity: 0.8,
                zIndex: 11,
                visible: true,
            })
        );
    }

    routeShow(connectionId: number, routeTypeId: number) {
        if (!this.route || this.connectionId != connectionId || this.routeTypeId != routeTypeId) {
            this.loadedArea = null;
            if (this.route && this.connectionId && this.routeTypeId) {
                this.routeRemove(this.connectionId, this.routeTypeId);
            }
            if (connectionId && routeTypeId) {
                this.connectionId = connectionId;
                this.routeTypeId = routeTypeId;
                let filter: ApiFilterBuilder = new ApiFilterBuilder(1);
                this.token = (Date.now() * 1000 + Math.random() * 1000)
                    .toString(16)
                    .replace(/\./g, '');
                this.api
                    .getData(
                        'post',
                        '/routes/query_with_details' + filter.getUri(),
                        { connection_id: connectionId, route_type_id: routeTypeId },
                        z.any(),
                        z.any()
                    )
                    .then(this.routeOnLoad.bind(this, this.token))
                    .catch(err => {
                        console.error('routeShow', err);
                        // resetFilterQuery();
                    });
                Targeo.Base.Map.getContainer().addEventListener('mousemove', this.onMouseMove);
            }
        }
    }

    public routeRemove(connectionId: number, routeTypeId: number) {
        console.log(
            'routeRemove',
            this.connectionId === connectionId,
            this.routeTypeId === routeTypeId
        );
        if (this.connectionId === connectionId && this.routeTypeId === routeTypeId) {
            if (this.uncommitted) {
                this.map.modules.Controls.removeControl('route-uncommitted');
                this.uncommitted = false;
                this.api.getData(
                    'post',
                    '/route/' + this.route.id + '/discard_changes',
                    {},
                    z.any(),
                    z.any()
                );
            }
            Targeo.Base.Map.getContainer().removeEventListener('mousemove', this.onMouseMove);
            if (this.route) {
                if (this.route.polylines) {
                    for (let i = 0; i < this.route.polylines.length; i++) {
                        this.routeLayer.remove(this.route.polylines[i].id);
                    }
                }
                this.pointsRemove();
                this.route = null;
                this.connectionId = null;
                this.routeTypeId = null;
                this.loadedArea = null;
                this.map.tileLayerRemove('labels');
            } else {
                this.token = null;
            }
        }
    }

    private routeOnLoad(token: string, json: any) {
        if (this.token === token && json.id && json.params && json.points) {
            this.pointsAdd(json.points);
            this.route = {
                id: json.id,
                params: json.params,
                polylines: [],
            };
            for (let i in this.route.params) {
                if (i.match(/^(min|max)(X|Y)$/)) {
                    this.route.params[i] = parseFloat(this.route.params[i]);
                }
            }
            this.onZoomToBoundsTimeout = setTimeout(this.routeFetch.bind(this), 100);
            this.map.zoomToBounds(this.route.params, false, [65, 125, 25, 125]);
            this.map.tileLayerAdd(this.labelsLayer);
        }
    }

    pointsAdd(points: any[]) {
        for (let i = 0, ii = points.length; i < ii; i++) {
            this.points.push(this.pointAdd(points[i], i, points.length));
        }
    }

    private pointAdd(point: any, idx: number, count: number) {
        let label = null;
        let draggable = false;
        let c = '#ffffff';
        if (idx == 0) {
            c = '#529749';
        } else if (idx == count - 1) {
            c = '#db2122';
        } else {
            label = { text: idx.toString(), size: 10, color: '#333333', offset: { x: 0, y: 0 } };
            c = this.pointGetColor(point);
            draggable = this.canEditRoute();
        }
        point = new Targeo.MapObject.Oval(
            { x: parseFloat(point.x), y: parseFloat(point.y) },
            10,
            null,
            {
                zIndex: 210 + idx / 1000,
                strokeWeight: 2,
                strokeColor: '#333333',
                fillColor: c,
                label: label,
                spread: false,
                draggable: draggable,
                fGetContextMenu: draggable
                    ? function () {
                          return ['removeobject'];
                      }
                    : function () {
                          return ['*'];
                      },
            }
        );
        if (draggable) {
            point.listen('onDrag', this.onRouteDrag, false, this);
            point.listen('onDragEnd', this.onRouteDragEnd, false, this);
            point.listen(
                'onClick',
                function (this: RouteOnMap, evt: any) {
                    if (evt.originalEvent.shiftKey) {
                        this.map.UORemove(evt.target.id);
                    }
                },
                false,
                this
            );
            point.listenOnce('onRemove', this.onViaPointRemove, false, this);
        }
        point.point_order = idx;
        this.map.UOAdd(point);
        return point;
    }

    private pointGetColor(point: any): string {
        return '#ffffff';
    }

    pointsRemove() {
        if (this.points) {
            for (let i = 0, ii = this.points.length; i < ii; i++) {
                if (this.points[i]) {
                    this.points[i].unlisten('onRemove', this.onViaPointRemove, false, this);
                    this.map.UORemove(this.points[i].id);
                }
            }
            this.points = [];
        }
    }

    routeFetch() {
        if (this.route && this.route.id) {
            if (this.onZoomToBoundsTimeout) {
                clearTimeout(this.onZoomToBoundsTimeout);
                this.onZoomToBoundsTimeout = null;
            }
            let currentArea = this.map.getVisibleExtent();
            currentArea.minX -= (currentArea.maxX - currentArea.minX) / 2;
            currentArea.maxX += (currentArea.maxX - currentArea.minX) / 2;
            currentArea.minY -= (currentArea.maxY - currentArea.minY) / 2;
            currentArea.maxY += (currentArea.maxY - currentArea.minY) / 2;
            if (
                this.recentZoom != this.map.getZoom() ||
                !this.loadedArea ||
                currentArea.minX < this.loadedArea.minX ||
                currentArea.minY < this.loadedArea.minY ||
                currentArea.maxX > this.loadedArea.maxX ||
                currentArea.maxY > this.loadedArea.maxY
            ) {
                this.recentZoom = this.map.getZoom();
                if (
                    this.uncommitted ||
                    (currentArea.minX <= this.route.params.maxX &&
                        currentArea.maxX >= this.route.params.minX &&
                        currentArea.minY <= this.route.params.maxY &&
                        currentArea.maxY >= this.route.params.minY)
                ) {
                    this.api
                        .getData(
                            'post',
                            '/route/' + this.route.id + '/get_geometry',
                            {
                                extent: currentArea,
                                zoom: this.recentZoom,
                                uncommitted: this.uncommitted,
                            },
                            z.any(),
                            z.any()
                        )
                        .then(this.routeOnFetch.bind(this))
                        .catch(err => {
                            console.error('routeFetch', err);
                        });
                }
            }
        }
    }

    routeOnFetch(json: any) {
        console.log('MapRoute, routeOnFetch', json, json.routeid == this.route.id);
        if (json.routeid == this.route.id) {
            var i, ii, j, k, p, zone;
            if (json.bounds) {
                this.loadedArea = json.bounds;
                for (i in this.loadedArea) {
                    this.loadedArea[i] = parseFloat(this.loadedArea[i]);
                }
            }
            if (this.route) {
                if (this.route.polylines) {
                    for (i = 0; i < this.route.polylines.length; i++) {
                        this.routeLayer.remove(this.route.polylines[i].id);
                    }
                }
            }
            if (this.route) {
                this.route.polylines = [];
                this.map.getObjectManager().disableRefreshing('LastMile:Route');
                if (json.data) {
                    this.recentZoom = this.map.getZoom();
                    let style;
                    let zIndex = 202;
                    for (i = 0; i < json.data.length; i++) {
                        style = this.getSegmentStyle(i);
                        for (j = 0; j < json.data[i].length; j++) {
                            if (json.data[i][j].length > 0) {
                                p = new Targeo.MapObject.Polyline([json.data[i][j]], {
                                    drawStyle: style,
                                    zIndex: zIndex,
                                });
                                p.segNum = [i, j];
                                p._style = style;
                                this.route.polylines.push(p);
                                this.routeLayer.add(p);
                            }
                        }
                    }
                }
                this.map.getObjectManager().enableRefreshing('LastMile:Route');
            }
        }
    }

    private getSegmentStyle(idx: number) {
        return this.routeStyle;
    }

    public refreshPointsOrder() {
        for (let i = 1; i < this.points.length - 1; i++) {
            let point = this.points[i];
            if (point.point_order != i) {
                point.setLabel({
                    text: i.toString(),
                    size: 10,
                    color: '#333333',
                    offset: { x: 0, y: 0 },
                });
                point.point_order = i;
            }
        }
    }

    public destroy() {
        if (this.route && this.connectionId && this.routeTypeId) {
            this.map.getObjectManager().disableRefreshing('LastMile:Route');
            this.routeRemove(this.connectionId, this.routeTypeId);
            this.map.getObjectManager().enableRefreshing('LastMile:Route');
        }
        this.map.unlisten('onMoveEnd', this.routeFetch, false, this);
        this.map.unlisten('onZoomChange', this.routeFetch, false, this);
        this.map.tileLayerRemove('junctions');
        console.log('MapRoute, destroy');
    }

    private onMouseMove(evt: any) {
        if (!this.routeDragging && this.canEditRoute()) {
            if (this.routeDragPointerHideTimeout) {
                clearTimeout(this.routeDragPointerHideTimeout);
            }
            let rect = Targeo.Base.Map.getContainer().getBoundingClientRect();
            evt.pixel = [evt.pageX - rect.x, evt.pageY - rect.y];
            let mapObjects = this.map.getObjectManager().getObjectsAtPixel(evt);
            let routeEnds = mapObjects.filter((s: any) => this.points.indexOf(s) >= 0);
            let routeLines = mapObjects.filter((s: any) => s.segNum);
            if (!routeEnds.length && routeLines.length) {
                if (!this.routeDragPointer) {
                    this.routeDragPointer = new Targeo.MapObject.Oval(
                        Targeo.Base.Map.pixelToCoordinate(evt.pixel),
                        10,
                        null,
                        {
                            zIndex: 250,
                            strokeWeight: 1,
                            strokeColor: '#333333',
                            fillColor: '#ffffff',
                            draggable: true,
                            label: {
                                text: '+',
                                size: 10,
                                color: '#333333',
                                offset: { x: 0, y: 0 },
                            },
                            spread: false,
                        }
                    );
                    this.routeDragPointer.listen('onDrag', this.onRouteDrag, false, this);
                    this.routeDragPointer.listen('onDragEnd', this.onRouteDragEnd, false, this);
                    this.map.UOAdd(this.routeDragPointer);
                    this.routeDragPointer.segment = routeLines[0].segNum[0];
                } else {
                    this.routeDragPointer.setCoordinates(
                        Targeo.Base.Map.pixelToCoordinate(evt.pixel)
                    );
                }
            } else if (this.routeDragPointer) {
                this.map.UOHide(this.routeDragPointer.id);
                this.routeDragPointerHideTimeout = setTimeout(
                    function (this: RouteOnMap) {
                        if (this.routeDragPointer) {
                            this.map.UORemove(this.routeDragPointer.id);
                            this.routeDragPointer = null;
                        }
                    }.bind(this),
                    50
                );
            }
        }
    }

    private onRouteDrag(evt: any) {
        if (this.canEditRoute()) {
            if (this.routeDragPointerHideTimeout) {
                clearTimeout(this.routeDragPointerHideTimeout);
                this.routeDragPointerHideTimeout = null;
            }
            if (this.routeDragPointer && !this.routeDragPointer.visible) {
                this.map.UOShow(this.routeDragPointer.id);
            }
            if (this.routeDragging && this.routeDragging.traceTimeout) {
                clearTimeout(this.routeDragging.traceTimeout);
            }
            let rect = Targeo.Base.Map.getContainer().getBoundingClientRect();
            let pixel = [evt.originalEvent.pageX - rect.x, evt.originalEvent.pageY - rect.y];
            let coords = this.map.pixelToCoordinate(pixel);
            if (evt.target.point_order) {
                //dragging existing point
                if (this.routeDragPointer) {
                    this.map.UORemove(this.routeDragPointer.id);
                    this.routeDragPointer = null;
                }
            }
            if (!this.routeDragging) {
                if (this.routeDragPointer) {
                    let segment = this.routeDragPointer.segment;
                    if (typeof(segment) == 'number' && this.points[segment] && this.points[segment + 1]) {
                        this.routeDragging = {
                            segments: [segment],
                            points: [this.points[segment].coords, coords, this.points[segment + 1].coords]
                        };
                    } else {
                        return;
                    }
                } else {
                    let point_order = evt.target.point_order;
                    if (typeof(point_order) == 'number' && this.points[point_order - 1] && this.points[point_order + 1]) {
                        this.routeDragging = {
                            segments: [point_order - 1, point_order],
                            points: [
                                this.points[point_order - 1].coords,
                                coords,
                                this.points[point_order + 1].coords,
                            ]
                        };
                    } else {
                        return;
                    }
                }
            } else {
                this.routeDragging.points[1] = coords;
            }
            this.routeDragging.currentPixel = pixel;
            if (
                !this.routeDragging.lastPixel ||
                Math.abs(this.routeDragging.lastPixel[0] - pixel[0]) > 15 ||
                Math.abs(this.routeDragging.lastPixel[1] - pixel[1]) > 15
            ) {
                this.routeDragging.traceTimeout = setTimeout(this.traceRouteOnDrag.bind(this), 50);
            }
        }
    }

    private traceRouteOnDrag() {
        if (this.routeDragging && this.canEditRoute()) {
            this.routeDragging.lastPixel = this.routeDragging.currentPixel;
            let params: any = {
                rpc: 'FindRouteLive',
                pts: JSON.stringify(this.routeDragging.points),
                via: 1,
                z: this.map.getZoom(),
                js: 0,
            };
            Object.keys(params).forEach((key, index) => {
                params[key] = key + '=' + encodeURIComponent(params[key]);
            });
            params = Object.values(params).join('&');
            axios
                .get(
                    _TARGEO_GLOBALS.url +
                        '/service.html?' +
                        params +
                        '&' +
                        _TARGEO_GLOBALS.urlParams,
                    {
                        withCredentials: true,
                    }
                )
                .then(
                    ((response: any) => {
                        this.liveRouteShow(response.data);
                    }).bind(this)
                );
        }
    }

    private liveRouteShow(json: any) {
        if (this.routeDragging && !this.routeDragging.ended) {
            if (this.routeDragging.route) {
                this.routeLayer.remove(this.routeDragging.route.id);
            } else {
                for (let i = 0; i < this.route.polylines.length; i++) {
                    if (
                        this.routeDragging.segments.indexOf(this.route.polylines[i].segNum[0]) >= 0
                    ) {
                        this.routeLayer.hide(this.route.polylines[i].id);
                    }
                }
            }
            this.routeDragging.route = new Targeo.MapObject.Polyline(json['rs'], {
                drawStyle: this.getSegmentStyle(this.routeDragging.segments[0]),
            });
            this.routeLayer.add(this.routeDragging.route);
        }
    }

    private onRouteDragEnd(evt: any) {
        if (!this.canEditRoute()) {
            console.log('RouteOneMap, onRouteDragEnd, canEditRoute = false');
            return;
        }
        if (this.routeDragging && !this.routeDragging.ended) {
            this.routeDragging.ended = true;
            for (let i = 1; i < this.points.length - 1; i++) {
                this.points[i].setDraggable(false);
            }
            if (this.routeDragPointer) {
                this.map.UORemove(this.routeDragPointer.id);
                this.routeDragPointer = null;
            }
            let newcoords = this.map.pixelToCoordinate(this.routeDragging.currentPixel);
            let points = this.points.map(p => p.coords);
            let draggedRoute = this.routeDragging.route;
            let segments = this.routeDragging.segments;
            if (segments.length === 1) {
                points.splice(segments[0] + 1, 0, newcoords);
            } else {
                points[segments[1]] = newcoords;
            }
            points = points.slice(1, -1).map(p => {
                return { type: 'Point', coordinates: [p.x, p.y] };
            });
            this.api
                .getData(
                    'post',
                    '/route/' + this.route.id + '/change_via_points',
                    { points: points },
                    z.any(),
                    z.any()
                )
                .then(
                    function (this: RouteOnMap) {
                        if (segments.length === 1) {
                            this.points.splice(
                                segments[0] + 1,
                                0,
                                this.pointAdd(newcoords, segments[0] + 1, this.points.length + 1)
                            );
                        }
                        this.refreshPointsOrder();
                        this.setUncommitted();
                        this.loadedArea = null;
                        this.routeFetch();
                        if (draggedRoute) {
                            this.routeLayer.remove(draggedRoute.id);
                        }
                        this.routeDragging = null;
                        for (let i = 1; i < this.points.length - 1; i++) {
                            this.points[i].setDraggable(true);
                        }
                    }.bind(this)
                )
                .catch(err => {
                    console.error('changeViaPoints', err);
                });
        }
    }

    private onViaPointRemove(evt: any) {
        if (!this.canEditRoute()) {
            return;
        }
        let point = evt.target;
        for (let i = 0; i < this.route.polylines.length; i++) {
            this.routeLayer.remove(this.route.polylines[i].id);
        }
        this.points.splice(point.point_order, 1);
        this.refreshPointsOrder();
        let points = this.points
            .map(p => {
                return { type: 'Point', coordinates: [p.coords.x, p.coords.y] };
            })
            .slice(1, -1);
        this.api
            .getData(
                'post',
                '/route/' + this.route.id + '/change_via_points',
                { points: points },
                z.any(),
                z.any()
            )
            .then(
                function (this: RouteOnMap) {
                    this.setUncommitted();
                    this.loadedArea = null;
                    this.routeFetch();
                }.bind(this)
            )
            .catch(err => {
                console.error('onViaPointRemove', err);
            });
    }

    private setUncommitted() {
        if (!this.uncommitted) {
            this.uncommitted = true;
            this.loadedArea = null;
            this.uncommittedMapBar.innerHTML = 'Trasa została zmieniona';
            let cancelButton = document.createElement('span');
            cancelButton.style.cssText =
                'display: inline-block; background-color: #555555; border-radius: 3px; padding: 3px 10px; color: #ffffff; cursor: pointer; max-height: 18px;line-height: 18px;';
            cancelButton.innerHTML = 'anuluj';
            this.uncommittedMapBar.appendChild(cancelButton);
            cancelButton.addEventListener('click', this.setCommitted.bind(this, false));
            let saveButton = document.createElement('span');
            saveButton.style.cssText =
                'display: inline-block; background-color: #313131; border-radius: 3px; padding: 3px 10px; color: #ffffff; cursor: pointer; max-height: 18px;line-height: 18px;';
            saveButton.innerHTML = 'zachowaj';
            this.uncommittedMapBar.appendChild(saveButton);
            saveButton.addEventListener('click', this.setCommitted.bind(this, true));
            this.map.modules.Controls.addControl('route-uncommitted', this.uncommittedMapBar, {
                align: 'bottom-left',
                edge: true,
                visibilityPriority: 1000,
                attractPriority: 1000,
            });
        }
    }

    private setCommitted(save: boolean) {
        // celowo samo can_write, bez limitu transakcji: wyczerpany limit nie może uwięzić
        // niezatwierdzonych zmian, które trzeba jeszcze zachować albo anulować
        if (!get(canWrite)) {
            return;
        }
        if (this.route === null) {
            // https://lupus.automapa.pl/organizations/automapa/issues/4930
            console.error('setCommitted: route is null');
            return;
        }
        this.loadedArea = null;
        this.map.modules.Controls.removeControl('route-uncommitted');
        this.api
            .getData(
                'post',
                '/route/' + this.route.id + '/' + (save ? 'commit_changes' : 'discard_changes'),
                {},
                z.any(),
                z.any()
            )
            .then(
                function (this: RouteOnMap) {
                    this.reloadRoute();
                    if (save) {
                        this.dispatchEvent(
                            new CustomEvent('routechange', {
                                detail: {
                                    connection_id: this.connectionId,
                                    route_type_id: this.routeTypeId,
                                },
                            })
                        );
                    }
                }.bind(this)
            )
            .catch(err => {
                console.error('setCommitted', err);
            });
    }

    private reloadRoute() {
        let connectionId = this.connectionId;
        let routeTypeId = this.routeTypeId;
        this.routeRemove(connectionId, routeTypeId);
        this.routeShow(connectionId, routeTypeId);
    }

    private isRoutingAvailable(): boolean {
        let settings = get(app).settingsReadonly;
        let limit = settings.max_transactions_per_month;
        let allowExceeding = settings?.allow_limit_exceeding;
        let current = get(routes).currentTransactionCount;
        return allowExceeding || !limit || !current || limit > current.count;
    }

    /**
     * Edycja dotyczy trasy zapisanej w bazie, więc wymaga can_write - bez niego backend odrzuca
     * change_via_points/commit_changes/discard_changes 403 z markerem read_only. Trasy wyznaczane
     * narzędziem na mapie (Targeo FindRoute) nie idą tą ścieżką i pozostają dostępne dla każdego.
     *
     * Limit transakcji sprawdzamy osobno (isRoutingAvailable) - to inny powód blokady niż uprawnienia.
     */
    private canEditRoute(): boolean {
        return get(canWrite) && this.isRoutingAvailable();
    }
}
